/* eslint-disable */
let _markers = [];
// let _searchUsingMap = true;
// import Cookies from 'cookie-js';
const $ = require('jquery');
const select2 = require('select2');
const $dynamicfilterForm = $('.allvillas__form--dynamicfilter');
const $allvillasForm = $('.allvillas__form');
const $allvillasFormSubmit = $('.allvillas__form__item__btn');
const $dynamicfilterClearFilter = $('.allvillas__dynamic-selections');
const $mapToggle = $('.allvillas__view__map');
const $dynamicFilterToggle = $('.allvillas__view__dynamicfilter-toggle');
const $dynamicfilterCloseButton = $('.allvillas__form--dynamicfilter__filters-btn-close');
const $allvillasMapCloseButton = $('.allvillas__map__close-btn');
const $allvillasMobileMaptoggle = $('.allvillas__total-items__toggle-mobile-map');
const $allvillas__view__mobile = $('.allvillas__view__mobile-info--dates');
const $dynamicFilterResultsHelper = $('.allvillas__form--dynamicfilter__results-helper');
const $singleVillasMobileBookFormButton = $('.single-villas__booking-form--mobile__button');
const $singleVillasMobileBookFormCloseButton = $('.single-villas__booking-form__close');
// const $allvillasFormButton = $('.allvillas__form__item__btn.link.link--button');
const delay = 1000;
var Cookies = require('js-cookie');
// const Cookies = require('cookie-js');
// Cookies.set('userfilters', {}, { expires: 7 });
// function updateCookie(key, value, cookieName = 'userfilters', Cookies) {
// 	cookieValue = Cookies.get(cookieName);
// 	cookieValue.key = value;
// 	Cookies.set(cookieName, cookieValue);
// 	return Cookies.get('userfilters');
// }

let storage = '';
if (storage == '') {
	storage = window.localStorage;
}

$(() => {
	if ($('body').hasClass('page-template-villas')) {
		//


		submitFilters();
		initSubmit();
		updateVillas();
		dynamicFilterVillas();
		dynamicFiltersInit();
		initSelect2();
		paginationCLicked();
		showFilters();
		closeFilters();
		gridList();
		initPlusMinus();
		guestsFilterToggle();
		dynamicfilterClearFilterInit();
		toggleMapInit();
		dynamicfilterCloseButtonInit();
		dynamicFilterToggle();
		allvillasMapCloseButtonInit();
		allvillasMobileMaptoggleInit();
		sortbyInit();
		updateHtmlFromLocalStorage(storage);
		dynamicfiltersClearAllButtonInit();
		allvillas__view__mobile();
		dynamicFilterResultsHelperToggle();
		closeGuestsonClickOutside();
		// propertiesToMarkers(dynamicmap._properties, _map);
		// pinSidebar()
		_markers = dynamicmap._markers;
	}

	if ($('body').hasClass('single-villas')) {
		guestsFilterToggle();
		initPlusMinus();
		initSubmitSingleBookingForm();
		singleVillasMobileBookFormButtonToggle();
		hideSingleVillasMobileBookFormButtonToggle();
		closeGuestsonClickOutside();
	}


	if ($('body').hasClass('home') || $('body').hasClass('page-template-pagebuilder') || $('body').hasClass('single-destination')) {
		initSubmit();
		initPlusMinus();
		showBookingMask();
		closeBookingMask();
		guestsFilterToggle();
		initSelect2();
		hideBookingMask();
	}
});


function closeGuestsonClickOutside() {
	$guestspopup = $('.villas-filters__label--guests');
	$('body').on('click', function (event) {
		if (!$guestspopup.is(event.target)
			&& !$guestspopup.next().is(event.target)
			&& $guestspopup.next().has(event.target).length === 0
			&& $guestspopup.has(event.target).length === 0) {
			$guestspopup.next().hide();
		}
	});
}

function singleVillasMobileBookFormButtonToggle() {
	$singleVillasMobileBookFormButton.on('click', function (e) {
		e.preventDefault();
		$('body').addClass('mobile-search-is-open');
		$('.single-villas__booking-form--mobilemodal').css('display', 'flex');
	});

	$singleVillasMobileBookFormCloseButton.on('click', function (e) {
		e.preventDefault();
		$('body').removeClass('mobile-search-is-open');
		$('.single-villas__booking-form--mobilemodal').css('display', 'none');
	});
}

function initSubmitSingleBookingForm() {
	$('.single-villas__booking-form_submit').removeClass('hide');
	$('.single-villas__booking-form_submit').on('click', function (e) {
		$('.single-villas__booking-form__loading').addClass('active');
		$('.booking-form-response').empty();
		e.preventDefault();
		$(this).closest('form').submit();
	});
}
function dynamicFilterResultsHelperToggle() {
	$dynamicFilterResultsHelper.on('click', function (e) {
		$dynamicfilterCloseButton.trigger('click');
	});
}

function sortbyInit() {
	//desktop sorting
	$('.allvillas__view__sort__select').on('change', function (e) {
		$('[name="sortby"]').val($(this).val())
		storage.setItem('SortBy', $(this).val());
		$dynamicfilterForm.submit();

	});

	//mobile sorting sorting
	$('.allvillas__form--dynamicfilter__sort__select').on('change', function (e) {
		$('[name="sortby"]').val($(this).val())
		storage.setItem('SortBy', $(this).val());
		$dynamicfilterForm.submit();
	});
}

function allvillas__view__mobile() {
	$allvillas__view__mobile.on('click', function () {
		$('.villas-filters__filters-btn').trigger('click');
	});
}

function allvillasMobileMaptoggleInit() {
	$allvillasMobileMaptoggle.on('click', function (e) {
		$('.allvillas__map').addClass('map-open');

		_map.setZoom(6);
	});
}
function allvillasMapCloseButtonInit() {
	$allvillasMapCloseButton.on('click', function (e) {
		$('.allvillas__map').removeClass('map-open')
	});
}

function dynamicFilterToggle() {
	$dynamicFilterToggle.on('click', function (e) {
		e.preventDefault();
		$('.allvillas__form__dynamic-wrapper').show();
		// $('body').addClass('modal-open');
	});
}

function dynamicfilterCloseButtonInit() {
	$dynamicfilterCloseButton.on('click', function (e) {
		e.preventDefault();
		$('.allvillas__form__dynamic-wrapper').hide();
		$('body').removeClass('modal-open');
	});
}

function toggleMapInit() {
	$mapToggle.on('click', function () {
		$mapToggle.toggleClass('hidemap');
		if ($mapToggle.hasClass('hidemap')) {
			_map.setZoom(6);//map was lossing its zoom // just a fast fix for a small bug . . boundaries and center is static
			enableSearchUsingMap();
			// 			console.log('enable search using map');
		} else {
			disableSearchUsingMap();
		}
		$('.allvillas__map').toggleClass('hidemap');
		$('.allvillas__results').toggleClass('hidemap');
		updateScrollTrigger();
	});
}

function updateScrollTrigger() {
	setTimeout(function () {
		$('.allvillas__form__item').css('overflow', 'hidden');
		window.dispatchEvent(new Event('resize'));
		$('.allvillas__form__item').css('overflow', 'unset');
	}, 1000);
}

function dynamicfilterClearFilterInit() {
	$dynamicfilterClearFilter.on('click', '.allvillas__dynamic-selections__item__clear-filter', function (event) {
		var clickedItem = $(event.target);
		let value = $(this).parent().data('value'); // Rethymno
		let attribute = $(this).parent().data('attribute'); //City
		if (attribute === 'bedrooms') {
			$('input[name="bedrooms"]').attr('value', 0).trigger('change');
			$('.bedrooms-current').empty().html(0);
			$dynamicfilterForm.submit();
		}
		if (attribute === 'bathrooms') {
			$('input[name="bathrooms"]').attr('value', 0).trigger('change');
			$('.bathrooms-current').empty().html(0);
			$dynamicfilterForm.submit();
		}
		if (attribute === 'Region') {
			$('input[name="Region"]').attr('value', 0).trigger('change');
			$dynamicfilterForm.submit();
		}


		const checkboxes = document.querySelectorAll('input[name="' + attribute + '[]"]');
		checkboxes.forEach(function (checkbox) {
			if (checkbox.checked) {
				if (checkbox.value === value) {
					checkbox.checked = false;
					$dynamicfilterForm.submit();
				}
			}
		});

		// Clean Up dynamic Filters from localstorage also
		//Clear Prices from and to 
		storage.setItem('City', '');
		storage.setItem('Bedrooms', '0');
		storage.setItem('SortBy', '');
		const $pricefrom = $('[name="pricefrom"]');
		const $priceto = $('[name="priceto"]');
		storage.setItem('PriceRange', { 'min': $priceto.val($priceto.attr('max')), 'max-price': $pricefrom.val($pricefrom.attr('min')) });

	});

	// 	$dynamicfilterClearFilter.delegate('.allvillas__dynamic-selections__item__clear-filter', 'click', (e) => {
	// 	});
	// 	$dynamicfilterClearFilter.on('click', function(){
	// 		let value = $(this).parent().data('value'); // Rethymno
	// 		let attribute = $(this).parent().data('attribute'); //City
	// 
	// 		var $targetCheckbox = $('input[type="checkbox"]').filter(function(attribute) {
	// 			// Use the "for" attribute of the label to find the associated checkbox
	// 			var inputvalue = $(this).value();
	// 			// var label = $('label[for="' + labelFor + '"]');
	// 			
	// 			// Check the text content of the label
	// 			return inputvalue === attribute;
	// 		});
	// 	// 		console.log($targetCheckbox);
	// 	});
}

function initSelect2() {
	//regions
	const select2 = $('.villas-filters__select2__item').select2({
		minimumResultsForSearch: Infinity,
		dropdownParent: $('.allvillas__form'),
	});
	// sort desktop
	const select21 = $('.allvillas__view__sort__select').select2({
		minimumResultsForSearch: Infinity,
		dropdownParent: $('.allvillas__view__sort__select').parent(),
	});
	//  sort by in mobile
	const select22 = $('.allvillas__form--dynamicfilter__sort__select').select2({
		minimumResultsForSearch: Infinity,
		dropdownParent: $('.allvillas__form--dynamicfilter__sort__select').parent(),
	});
}

function initSubmit() {
	$allvillasFormSubmit.on('click', function (e) {
		e.preventDefault();
		// 		console.log('allvillas__form__item__btn clicked');
		$allvillasForm.submit();
	});
}

function fixHideShowBookNowAvailabilityButton() {
	$('.single-villas__booking-form_submit').show();
	$('.single-villas__booking-form__rates__info').show();
	$('.single-villas__booking-form--book__info').hide();
	$('.single-villas__booking-form__book').hide();
	updateScrollTrigger();
}


function initPlusMinus() {
	const $minus = $('.minus');
	const $plus = $('.plus');

	$minus.on('click', function () {
				// console.log();
		fixHideShowBookNowAvailabilityButton();

		if (parseInt($(this).next().html()) !== 0) {
			$(this).next().html(parseInt($(this).next().html()) - 1);
			$('[name="' + $(this).next().data('input') + '"] ').val(parseInt($(this).next().html()));
		}
		if ($(this).next().data('input') === 'bedrooms') {
			storage.setItem('Bedrooms', parseInt($(this).next().html()));
			$dynamicfilterForm.submit();
		}
		if ($(this).next().data('input') === 'bathrooms') {
			storage.setItem('Bathrooms', parseInt($(this).next().html()));
			$dynamicfilterForm.submit();
		}

		if ($(this).next().data('input') === 'adults') {
			// $('.adults-current').empty().html($(this).prev().val()); 
			let children = parseInt($(this).parent().parent().find('.children-current').html());
			let adults = parseInt($('[name="' + $(this).next().data('input') + '"] ').val());
			let total = adults + children;
			// 			// console.log(total);
			console.log(adults);
			console.log(children);
			console.log(total);
			$('.villas-filters__label--guests--integer').empty().html(total);
		}

		if ($(this).next().data('input') === 'children') {
			// $('.children-current').empty().html($(this).prev().val()); 
			let children = parseInt($('[name="' + $(this).next().data('input') + '"] ').val());;
			let adults = parseInt($(this).parent().parent().find('.adults-current').html());
			let total = adults + children;
			// 			// console.log(total);
			console.log(adults);
			console.log(children);
			console.log(total);
			$('.villas-filters__label--guests--integer').empty().html(total);
		}
	});

	$plus.on('click', function () {
		console.log('egine click to plus');
		fixHideShowBookNowAvailabilityButton();
		if ($(this).prev().hasClass('bedrooms-current') && (parseInt($(this).prev().html()) < parseInt($(this).prev().data('max')))) {
			$(this).prev().html(parseInt($(this).prev().html()) + 1);
		} else {
			if (!$(this).prev().hasClass('bedrooms-current')) {
				// console.log('fall back');
				$(this).prev().html(parseInt($(this).prev().html()) + 1);
			}
		}

		$('[name="' + $(this).prev().data('input') + '"] ').val(parseInt($(this).prev().html()));
		//need to update all the adults-current // and children current in the form, or
		//update the values from the input type hidden 

		if ($(this).prev().data('input') === 'bedrooms') {
			//add bedroom exept data-max is not reached .. this is only for the filters overview page
			let $bedroomMax = $('.bedrooms-current').data('max');
			if (parseInt($bedroomMax) < parseInt($(this).prev().html())) {
				storage.setItem('Bedrooms', parseInt($(this).prev().html()));
			}
			$dynamicfilterForm.submit();
		}
		if ($(this).prev().data('input') === 'bathrooms') {
			//add bathrooms exept data-max is not reached .. this is only for the filters overview page
			let $bathroomMax = $('.bathrooms-current').data('max');
			if (parseInt($bathroomMax) < parseInt($(this).prev().html())) {
				storage.setItem('Bathrooms', parseInt($(this).prev().html()));
			}
			$dynamicfilterForm.submit();
		}
		if ($(this).prev().data('input') === 'adults') {
			// $('.adults-current').empty().html($(this).prev().val()); 
			let children = parseInt($(this).parent().parent().find('.children-current').html());
			let adults = parseInt($('[name="' + $(this).prev().data('input') + '"] ').val());
			let total = adults + children;
			// 			// console.log(total);
			$('.villas-filters__label--guests--integer').empty().html(total);
		}
		if ($(this).prev().data('input') === 'children') {
			// $('.children-current').empty().html($(this).prev().val()); 
			let children = parseInt($('[name="' + $(this).prev().data('input') + '"] ').val());;
			let adults = parseInt($(this).parent().parent().find('.adults-current').html());
			let total = adults + children;
			// 			// console.log(total);
			$('.villas-filters__label--guests--integer').empty().html(total);
		}
	});


}

function gridList() {
	const $villasOverview = $('.villas-overview');
	const $grid = $('.allvillas__view__grid');
	const $list = $('.allvillas__view__list');
	$grid.on('click', function (e) {
		$('.allvillas').removeClass('list');
		$(this).addClass('active');
		$list.removeClass('active');
		$villasOverview.removeClass('villas-overview--list');
	});
	$list.on('click', function (e) {
		$('.allvillas').addClass('list');
		$villasOverview.addClass('villas-overview--list');
		$grid.removeClass('active');
		$(this).addClass('active');
	});
}
//check a function to pagination's ajax calls 
function paginationCLicked() {
	$('.villas-overview__pagination').delegate('.pagination__list-item a', 'click', (e) => {
		e.preventDefault();
		const pageNumber = $(e.currentTarget).parent('li').data('pageno');
		updateVillasPaged(pageNumber, '.allvillas__form--dynamicfilter');
		$('html, body').animate({ scrollTop: 0 }, 0);
	});
}

//on form submit do nothing just refresh and submit the form native...
function updateVillas() {
	$allvillasForm.on('submit', function (event) { //this is a full refresh... so for now no ajax for this form 
	});
}

// Dynamic Filter
function dynamicFilterVillas() {
	$dynamicfilterForm.on('submit', function (event) {
		event.preventDefault();
		// clearMarkers();
		// disableSearchUsingMap();
		updateVillasPagedDebounced(1, '.allvillas__form--dynamicfilter');

	});
}

function disableSearchUsingMap() {
	dynamicmap._searchUsingMap = false;
	dynamicmap._searchUsingMapButton.style.opacity = '0.5';
	dynamicmap._searchUsingMapButton.textContent = 'Search Using Map is Off';
	storage.setItem('SearchUsingMap', 0);
	// 	console.log('Search using map disabled');
}


function enableSearchUsingMap() {
	dynamicmap._searchUsingMap = true;
	if (typeof dynamicmap._searchUsingMapButton.style !== 'undefined') {
		dynamicmap._searchUsingMapButton.style.opacity = '1';
		dynamicmap._searchUsingMapButton.textContent = 'Search Using Map is On';
	}
	storage.setItem('SearchUsingMap', 1);
	// 	console.log('Search using map enabled');
}

const updateVillasPagedDebounced = debounce(updateVillasPaged, delay);

function updateVillasPaged($page = 1, form = '.allvillas_form') {
    if ($(form).length) {
        let resultscontainer = $('.villas-overview');
        const $filterContainer = $('.allvillas__dynamic-selections');
        let formdata = $(form).serializeArray();
        let filteredFormData = formdata.filter(item => item.value !== '');
        let queryParams = filteredFormData.map(item => `${encodeURIComponent(item.name)}=${encodeURIComponent(item.value)}`).join('&');

        // Update the URL with the query parameters
        let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + queryParams;
        window.history.pushState({ path: newUrl }, '', newUrl);

        $('.villas-loader').addClass('loading');
        $('.allvillas__form--dynamicfilter__results-helper').css('display','flex');

        $.ajax({
            url: window.urls.ajax,
            type: 'post',
            data: {
                action: 'post_select2',
                data: $.param(filteredFormData),
                paged: $page
            },
            success: function (response) {
                $('.villas-loader').removeClass('loading');
				$('body').addClass('ajax-villas-loaded');

                if (typeof response !== 'string') {
                    if (response.errors.length > 0) {
                        resultscontainer.empty().append(response.errors[0].message);
                    }
                    if (response.pagination.html !== '') {
                        $('.villas-overview__pagination').empty().append(response.pagination.html);
                    }

                    if (response.total_posts > 12) {
                        $('.allvillas__total-items__number').empty().html('12');
                    } else {
                        $('.allvillas__total-items__number').empty().html(response.total_posts);
                    }
                    $('.allvillas__total-items__total').empty().html(response.total_posts);

                    $('.allvillas__form--dynamicfilter__results-helper span').empty().html('View ' + response.total_posts + ' results');

                    if (response.results !== '') {
                        resultscontainer.empty().append(response.results);
                    }
                    if (response.filters !== '') {
                        $filterContainer.empty().append(response.filters);
                    }
                    disableSearchUsingMap();
                    if (dynamicmap._searchUsingMap === false) {
                        if (response.markers !== '') {
                            let markersData = response.markers;

                            updateMarkers(markersData);
                        }
                    }
                    $('allvillas__form--dynamicfilter__clearall').show();
                    updateScrollTrigger();
					window.favourites.updateFavoriteButtons();
                }
            },
            error: function () {
                // console.log('could not make ajax call');
            }
        }).then(function () {
        });
    }
}

function updateHtmlFromLocalStorage(storage) {
	//find the city foreach and set active
	let $City = storage.getItem('City');

	if ($City !== null) {
		if ($City !== '') {
			let CityArray = $City.split(',');
			$.each(CityArray, function (index, value) {
				$('input[value="' + value + '"]').trigger('click');
			});
		}
	}


	//find the bedrooms as set active the html  and all the values of the inputs
	let $Bedrooms = storage.getItem('Bedrooms');
	if (parseInt($Bedrooms) > 0) {
		let hiddenBedrooms = $('input[type="hidden"][name="bedrooms"]');
		hiddenBedrooms.each(function () {
			$(this).val($Bedrooms).trigger('change');
		});
		$('.bedrooms-current').empty().html($Bedrooms);
	} else {
		$('.bedrooms-current').empty().html('0');
	}
	//find the sort by value and update also 
	let $SortBy = storage.getItem('SortBy');
	if (parseInt($Bedrooms) > 0 || $City !== '') {
		$dynamicfilterForm.submit();
	}
}

function createMarker(n, e, o, t, i, a, l, p) {
	// const timeout = 1000;
	let _infoWindow = null;
	// clearMarkers();
	// dynamicmap._markers = [];
	// _markers =[];
	const svg = `<svg fill="black" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
	<circle cx="120" cy="120" opacity="1" r="70" />
	<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">1</text>
	</svg>`;
	var d = new google.maps.Marker({
		position: new google.maps.LatLng(e, o),
		map: n,
		animation: google.maps.Animation.DROP,
		icon: {
			url: `data:image/svg+xml;base64,${btoa(svg)}`, anchor: new google.maps.Point(25, 25),
		}
	});
	dynamicmap._markers.push(d);
	return void 0 !== t && null !== t && d.setTitle(t), void 0 !== l && null !== l && d.setAnimation(l), void 0 !== i && null != i && (d.infowindow = new google.maps.InfoWindow({
		content: i
	}), google.maps.event.addListener(d, "click", function () {
		"undefined" != typeof _infoWindowExternalContainerId && null != _infoWindowExternalContainerId ? jQuery("#" + _infoWindowExternalContainerId).html(this.infowindow.getContent()) : (_infoWindow && _infoWindow.close(), _infoWindow = this.infowindow, this.infowindow.open(n, this));
	})), void 0 !== a && null !== a && a.extend(d.position), void 0 !== p && null !== p && d.setIcon(p), d;
}


function updateMarkers(markers) {
	// 	console.log('updateMarkers');
	// 	// console.log(_map);
	clearMarkers();
	dynamicmap._markers = [];
	// dynamicmap._properties = [];
	// dynamicmap._markers = [];
	let _boundary = new google.maps.LatLngBounds();
	// 	console.log('I have to update' + markers.length + 'markers');
	for (var e = markers.length, t = 0; t < e; t++) {
		// 		// console.log('updateMarkers', markers[t]); ok debug tested
		createMarker(_map, markers[t].latitude, markers[t].longitude, markers[t].title, markers[t].content, _boundary);
	}

	// 	console.log(dynamicmap._markers);
	markerCluster = new markerClusterer.MarkerClusterer({
		map: _map,
		markers: dynamicmap._markers
	});
	_map.fitBounds(_boundary);
}

//clear markers from properties
function clearMarkers() {// we need to remove al lthe markers form the map  that came from the overview
	hideMarkers();

	let markerToRemove = '';

	if (dynamicmap._properties !== null) {

	} else {
		// 		console.log('not clearing markers3');
	}

}


// Sets the map on all markers in the array.
function setMapOnAll(map) {
	for (let i = 0; i < dynamicmap._markers.length; i++) {
		dynamicmap._markers[i].setMap(map);
		markerCluster.setMap(map);
	}
	// 	// console.log('setmapon all ' + map + '--- for ' + dynamicmap._markers.length + ' markers');
	for (let i = 0; i < markerCluster.algorithm.markers.length; i++) {
		markerCluster.algorithm.markers[i].setMap(map);
		// markerCluster.setMap(null);
	}
}

// Removes the markers from the map, but keeps them in the array.
function hideMarkers() {
	// setMapOnAll(null);
	for (let i = 0; i < dynamicmap._markers.length; i++) {
		dynamicmap._markers[i].setMap(null);
		markerCluster.setMap(null);
	}

	if (typeof markerCluster.algorithm.markers !== 'undefined') {
		for (let i = 0; i < markerCluster.algorithm.markers.length; i++) {
			markerCluster.algorithm.markers[i].setMap(null);
			// markerCluster.setMap(null);
		}
	}
}

// Shows any markers currently in the array.
function showMarkers() {
	setMapOnAll(map);
}

// Deletes all markers in the array by removing references to them.
function deleteMarkers() {
	hideMarkers();
	dynamicmap._markers = [];
}


// function propertiesToMarkers(properties, map) {
// 
// 	for (var i = 0; i < properties.length; i++) {
// // 		// console.log({ lat: properties[i].latitude, lng: properties[i].longitude });
// 		let d = new google.maps.Marker({
// 			position: new google.maps.LatLng(properties[i].latitude, properties[i].longitude),
// 			map: map
// 		});
// 
// 		_markers.push(d);
// 	}
// 
// 	return _markers;
// }

// position: new google.maps.LatLng(e, o)



function clearSelections() {

	//need some work here to clear dynamic filters 
	// 	console.log('clear filters');
	//Select all locations in sidebars
	let $inputs = $('.dynamic-filters__input input.input-city');
	// 	console.log($inputs);
	$inputs.prop('checked', false);
	// Select Region
	const $RegionInput = $('[name="Region"]');
	$RegionInput.val('');
	//Select all bedrooms
	const $bedroomsCurrent = $('.bedrooms-current');
	const $bedroomsInput = $('[name="bedrooms"]');
	$bedroomsCurrent.empty().html(0); //visible to user
	$bedroomsInput.val('0');
	// select all bathrooms
	const $bathroomsCurrent = $('.bathrooms-current');
	const $bathroomsInput = $('[name="bathrooms"]');
	$bathroomsCurrent.empty().html(0); //visible to user
	$bathroomsInput.val('0');
	//Clear Prices from and to 
	storage.setItem('City', '');
	storage.setItem('Bedrooms', '0');
	storage.setItem('Bathrooms', '0');
	storage.setItem('SortBy', '');
	const $pricefrom = $('[name="pricefrom"]');
	const $priceto = $('[name="priceto"]');
	storage.setItem('PriceRange', { 'min': $priceto.val($priceto.attr('max')), 'max-price': $pricefrom.val($pricefrom.attr('min')) });

	$dynamicfilterForm.submit();

	//test try to enable search using map
	enableSearchUsingMap();
	if (window.innerWidth < 991) {
		$('.allvillas__form--dynamicfilter__filters-btn-close').trigger('click');
	}
	//BUG  can not enable bug the search using map
	dynamicmap._searchUsingMap = true;
	dynamicmap._searchUsingMapButton.style.opacity = '1';
	dynamicmap._searchUsingMapButton.textContent = 'Search Using Map is On';
	storage.setItem('SearchUsingMap', 1);
	$(dynamicmap._searchUsingMapButton).trigger('click');
	//force with that code 

}

function guestsFilterToggle() {
	$('.villas-filters__label--guests').on('click', function (event) {
		$(this).next().toggle();
		if (!$(this).is(event.target) && $(this).has(event.target).length === 0) {
			// Close the dropdown

			$(this).next().hide();
			// $(".dropdown-content").hide();
		}

	});

}

///Submit filter villas overview
function submitFilters() {
	$('.villas-filters__filters input[type=checkbox]').on('click', function (event) {
		if ($(this).hasClass('active')) {
			// clearSelections();
			$('.allvillas__form').submit();
		} else {
			// clearSelections();
			$(this).addClass('active');
			$(this).parent().addClass('active');
			$('.allvillas__form').submit();
		}
	});


	//selectes 2 trigger events on change 
	$('.villas-filters__select2__item').on('change', function () {
		// 		console.log('select2destination changed');
		// $('.allvillas__form').submit();
	});
}

function showFilters() {
	$('.villas-filters__filters-btn').on('click', function (e) {
		e.preventDefault();
		$('.villas-filters__filters').toggleClass('active');
		// $('body').addClass('menu-open');
	});
}

function closeFilters() {
	$('.villas-filters__filters-btn-close').on('click', function (e) {
		e.preventDefault();
		$('.villas-filters__filters').toggleClass('active');
		// $('body').removeClass('menu-open');
	});
}

function showBookingMask() {
	$('.home-booking-mask__mobile-button').on('click', function (e) {
		e.preventDefault();
		$('.villas-filters__filters').toggleClass('active');
		// $('body').addClass('menu-open');
	});
}

function closeBookingMask() {
	$('.villas-filters__filters-btn-close').on('click', function (e) {
		e.preventDefault();
		$('.villas-filters__filters').toggleClass('active');
		// $('body').removeClass('menu-open');
	});
}

function hideBookingMask() {
	let distanceFromFooter = $(document).innerHeight() - $(window).scrollTop() - $(window).innerHeight();
	let footerHeight = $('.footer').innerHeight();
	var scrollTimeout;
	$(window).scroll(function () {
		clearTimeout(scrollTimeout);
		scrollTimeout = setTimeout(function () {
			distanceFromFooter = $(document).innerHeight() - $(window).scrollTop() - $(window).innerHeight();
			footerHeight = $('.footer').innerHeight();
			if (distanceFromFooter <= footerHeight) {
				$('.home-booking-mask').css('opacity', 0);
				$('.home-booking-mask').css('pointer-events', 'none');
			} else {
				$('.home-booking-mask').css('opacity', 1);
				$('.home-booking-mask').css('pointer-events', 'unset');
			}
		}, 200);
	});
}

function hideSingleVillasMobileBookFormButtonToggle() {
	let distanceFromFooter = $(document).innerHeight() - $(window).scrollTop() - $(window).innerHeight();
	let footerHeight = $('.footer').innerHeight();
	var scrollTimeout;
	$(window).scroll(function () {
		clearTimeout(scrollTimeout);
		scrollTimeout = setTimeout(function () {
			distanceFromFooter = $(document).innerHeight() - $(window).scrollTop() - $(window).innerHeight();
			footerHeight = $('.footer').innerHeight();
			if (distanceFromFooter <= footerHeight && window.innerWidth < 991) {
				$('.single-villas__booking-form--mobile').css('opacity', 0);
				$('.single-villas__booking-form--mobile').css('pointer-events', 'none');
			} else {
				$('.single-villas__booking-form--mobile').css('opacity', 1);
				$('.single-villas__booking-form--mobile').css('pointer-events', 'unset');
			}
		}, 200);
	});
}

function dynamicFiltersInit() {

	const $pricefrom = $('[name="pricefrom"]');
	const $priceto = $('[name="priceto"]');
	const $city = $('.dynamic-filters__input input.input-city');


	$pricefrom.on('change', function () {
		// 		console.log($(this));
		const value = $(this).val();
		let numericValue = value.replace(/[^0-9.]/g, '');
		numericValue = value.replace(/,00/g, '');
		// const formattedValue = Number(numericValue).toLocaleString('fr-FR', {
		// 	minimumFractionDigits: 0,
		// 	maximumFractionDigits: 0,
		// });
		// Update the input's value with the formatted value
		$(this).val(numericValue);

		let $pricetovalue = $priceto.val();
		$pricetovalue = $pricetovalue.replace(/[^0-9.]/g, '');
		$pricetovalue = $pricetovalue.replace(/,00/g, '');
		storage.setItem('PriceRange', { 'min': $(this).val(numericValue), 'max-price': $pricetovalue });
		$dynamicfilterForm.submit();
		$('allvillas__form--dynamicfilter__clearall').show();
	});

	$priceto.on('change', function () {
		// 		console.log($(this));
		const value = $(this).val();

		let numericValue = value.replace(/[^0-9.]/g, '');
		numericValue = value.replace(/,00/g, '');
		const formattedValue = Number(numericValue).toLocaleString('fr-FR', {
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		});
		// Update the input's value with the formatted value
		$(this).val(numericValue);

		let $pricefromvalue = $pricefrom.val();
		$pricefromvalue = $pricefromvalue.replace(/[^0-9.]/g, '');
		$pricefromvalue = $pricefromvalue.replace(/,00/g, '');
		storage.setItem('PriceRange', { 'min': $pricefromvalue, 'max-price': $(this).val(numericValue) });


		$dynamicfilterForm.submit();
		$('allvillas__form--dynamicfilter__clearall').show();
	});

	$city.on('change', function () {
		$citiesArray = [];
		$.each($city, function (index, city) {
			if ($(city).prop('checked') === true) {
				$citiesArray.push($(city).attr('value'));
			}
		});
		$dynamicfilterForm.submit();
		$('allvillas__form--dynamicfilter__clearall').show();
	});
}

function dynamicfiltersClearAllButtonInit() {
	$clearButton = $('.allvillas__form--dynamicfilter__clearall');
	$clearButton.on('click', clearSelections);
	enableSearchUsingMap();
	// $('allvillas__form--dynamicfilter__clearall').hide();
}

// Debounce function
function debounce(func, wait, immediate) {
	let timeout;

	return function () {
		const context = this;
		const args = arguments;

		const later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};

		const callNow = immediate && !timeout;

		clearTimeout(timeout);
		timeout = setTimeout(later, wait);

		if (callNow) func.apply(context, args);
	};
}


$(window).on('load',()=>{
    // Function to populate the form fields with URL parameters
    function populateFormFromURL(form) {
        let urlParams = new URLSearchParams(window.location.search);
        urlParams.forEach((value, key) => {
            if (key.endsWith('[]')) {
                key = key.slice(0, -2); // Remove the trailing '[]'
                let $input = $(`${form} [name="${key}[]"]`);
                if ($input.length) {
                    if ($input.is(':checkbox') || $input.is(':radio')) {
                        $input.filter(`[value="${value}"]`).prop('checked', true);
                    } else {
                        $input.val(value);
                    }
                }
            } else {
                let $input = $(`${form} [name="${key}"]`);
                if ($input.length) {
                    if ($input.is(':checkbox') || $input.is(':radio')) {
                        $input.filter(`[value="${value}"]`).prop('checked', true);
                    } else {
                        $input.val(value);
                    }
                }
            }
        });
    }

    // Parse URL parameters and populate the form
    populateFormFromURL('.allvillas__form--dynamicfilter');

    // Call updateVillasPaged with the current form data on page load
    updateVillasPaged(1, '.allvillas__form--dynamicfilter');
});